<script lang="ts">
  /**
   * Modular live countdown. Wraps the shared rAF clock + the canonical
   * countdown formatter so every surface (duel timers, Beat Market round,
   * season banner) ticks identically. Pass an ISO timestamp via `end`; when
   * the deadline passes it renders `ended` (default "Ended").
   */
  import { useClock } from '$stores/clock.svelte';
  import { formatCountdown } from '$lib/utils/time';

  let { end, ended = 'Ended' }: { end: string; ended?: string } = $props();

  const clock = useClock();
  const secondsRemaining = $derived(Math.floor((new Date(end).getTime() - clock.now) / 1000));
</script>

<span>{secondsRemaining <= 0 ? ended : formatCountdown(secondsRemaining)}</span>
